import React from 'react';
import { createRoot } from 'react-dom/client';
import AdvancedSearch from '../modules/react/AdvancedSearch';

// eslint-disable-next-line import/prefer-default-export
export const loadLazyModules = container => {
  if (container === null) return;
  const modules = container.querySelectorAll('.advanced-search');
  if (modules.length > 0) {
    modules.forEach(module => {
      if (module.dataset.loaded !== 'true') {
        const root = createRoot(module);
        root.render(<AdvancedSearch {...module.dataset} />);
      }
      module.dataset.loaded = 'true';
    });
  }
};
